import * as angular from "angular";

import DataService from "../Services/DataService";

interface AppsModel {
    schoolsOpen: boolean;
}

interface AppsActions {
    schoolClick: (active: boolean, schoolId: number) => void;
    navigate: (path: string) => void;
}

interface AppsScope extends angular.IScope {
    model: AppsModel;
    actions: AppsActions;
}

class AppsController {
    private $scope: AppsScope;
    private $sce: angular.ISCEService;
    private $rootScope: angular.IRootScopeService;
    private dataService: DataService;

    private _frame: HTMLElement | null;

    constructor(
        $scope: AppsScope,
        $sce: angular.ISCEService,
        $rootScope: angular.IRootScopeService,
        dataService: DataService,
    ) {
        this.$scope = $scope;
        this.$sce = $sce;
        this.$rootScope = $rootScope;
        this.dataService = dataService;

        this._frame = document.querySelector<HTMLElement>(".login-frame");

        $scope.model = {
            schoolsOpen: false,
        };

        $scope.actions = {
            schoolClick: this.schoolClick.bind(this),
            navigate: this.navigate.bind(this),
        };

        if (
            !Reflect.has(globalThis, "wasRedirect") ||
            !Reflect.get(globalThis, "wasRedirect")
        )
            this.initialise();
    }

    private async initialise() {
        const school = document.querySelector<HTMLElement>(
            ".school-list .school-item.active",
        );

        if (!!school)
            school.scrollIntoView({ behavior: "instant", block: "center" });
    }

    private navigate(path: string) {
        this._frame.style.height = this._frame.offsetHeight + 1400 + "px";
        this._frame.classList.add("loading");
        this._frame.style.height = "200px";
        setTimeout(() => globalThis.location.href = path, 700);
    }

    private schoolClick(active: boolean, schoolId: number) {
        if (active) {
            this.$scope.model.schoolsOpen = !this.$scope.model.schoolsOpen;
        } else {
            globalThis.location.href = `./School/${schoolId}?ReturnUrl=~%2FApps`;
        }
    }
}

angular
    .module("datastore")
    .controller("AppsController", [
        "$scope",
        "$sce",
        "$rootScope",
        "dataService",
        AppsController,
    ]);

export default AppsController;
